export const RegEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const RegPhone = /^\(\+92\)3[0-9]{2}-[0-9]{3}-[0-9]{4}$/;
export const RegCNIC = /^[0-9]{5}[0-9]{6}[0-9]{1}$/;